export default __webpack_public_path__ + "static/media/delivery.4683810a.svg";